export default "<div class=\"text\" *ngIf=\"explanation\">\r\n    {{explanation}}\r\n</div>"